import React from 'react';
import IFrame from "./components";
import { Routes, Route, useSearchParams, BrowserRouter } from 'react-router-dom';
import translations from './translations';
import './App.css';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/miraeasset/securities/quote" element={<MiraeAssetApp />} />
            </Routes>
        </BrowserRouter>
    );
}

const MiraeAssetApp = () => {
    const [queryParameters] = useSearchParams();
    const [isin, language] = [queryParameters.get('ISIN'), queryParameters.get('LANGUAGE').toLowerCase()];
    const T = translations[language.toLowerCase() || 'en'];
    if (!isin || !language) {
        return <div>NO DATA</div>;
    }
    return <IFrame isin={isin} language={language} T={T} />;
}
export default App;